/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmDailyCountInfo } from './EvmDailyCountInfo';

export type KiteHomeDailyAccountCreatedInfo = {
    PTCACNT: string;
    CNGP: string;
    TRXHTP: KiteHomeDailyAccountCreatedInfo.TRXHTP;
    DCALIST: Array<EvmDailyCountInfo>;
};

export namespace KiteHomeDailyAccountCreatedInfo {

    export enum TRXHTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }


}

